function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "briefcase"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19 5h-3v-1c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v1h-3c-1.654 0-3 1.346-3 3v2c0 .883.391 1.67 1 2.22v6.78c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-6.78c.609-.55 1-1.337 1-2.22v-2c0-1.654-1.346-3-3-3zm-9-1h4v1h-4zm-6 4c0-.552.448-1 1-1h14c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1h-14c-.552 0-1-.448-1-1zm15 11c0 .552-.448 1-1 1h-12c-.552 0-1-.448-1-1v-6h2v1c0 .553.447 1 1 1s1-.447 1-1v-1h6v1c0 .553.447 1 1 1s1-.447 1-1v-1h2z"
}));

var Svg019Briefcase = function Svg019Briefcase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg019Briefcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/019-briefcase.355914dd.svg";
export { ForwardRef as ReactComponent };